import { createSelector } from "@reduxjs/toolkit";
import { type RootState } from "features/Application/globaltypes/redux";
import { type AssignAccountPack } from "features/Accounts/PackAssignmentModal/types";

export const getSelectedPacks = (state: RootState): AssignAccountPack[] => state.accounts.availablePacks.selected;

export const getSelectedPackIds = createSelector([getSelectedPacks], (selectedPacks): number[] =>
  selectedPacks.map((pack) => pack.packId),
);
